import React from 'react';
import moment from 'moment';
import { Languages } from 'util/appConstants';
import { categories } from 'util/appConstants';
import { InfoLabelsContainer, LabelsContainer, LabelHeading, LabelValue, SmallLabelValue } from '../styles';

export default function InfoBox({
  report,
  isFreecode,
  totalMaxScore,
  bestRunInput,
  getOvertimeUsed,
  timeUsed,
  completedAt,
  anonymiseReport,
}) {
  return (
    <InfoLabelsContainer>
      <LabelsContainer anonymiseReport={anonymiseReport}>
        <LabelHeading>Name</LabelHeading>
        <LabelValue>{report.ticket.name ?? report.candidate.name}</LabelValue>
      </LabelsContainer>
      {report.candidate.email && (
        <LabelsContainer anonymiseReport={anonymiseReport}>
          <LabelHeading>Email</LabelHeading>
          <LabelValue>{report.candidate.email}</LabelValue>
        </LabelsContainer>
      )}
      <LabelsContainer>
        <LabelHeading>Test</LabelHeading>
        <LabelValue>{report.test.name}</LabelValue>
        {report.ticket.isCandidateChoosesEnabled === false && (
          <SmallLabelValue>Chosen by the candidate</SmallLabelValue>
        )}
      </LabelsContainer>
      <LabelsContainer>
        <LabelHeading>Test Type</LabelHeading>
        <LabelValue>
          {report.test.adaptiveTest
            ? 'Adaptive multi-choice'
            : report.test.category === categories.CODE.category
            ? 'Freecode test'
            : 'Multi-choice'}
        </LabelValue>
      </LabelsContainer>
      {report.ticket.country && !anonymiseReport && (
        <LabelsContainer>
          <LabelHeading>Location</LabelHeading>
          <LabelValue>{report.ticket.country}</LabelValue>
        </LabelsContainer>
      )}
      {report.ticket.ip && !anonymiseReport && (
        <LabelsContainer>
          <LabelHeading>IP</LabelHeading>
          <LabelValue>{report.ticket.ip}</LabelValue>
        </LabelsContainer>
      )}
      {!isFreecode && (
        <LabelsContainer>
          <LabelHeading>Correct answers</LabelHeading>
          <LabelValue>
            {report.ticket.result} / {totalMaxScore}
          </LabelValue>
        </LabelsContainer>
      )}
      {!isFreecode && (
        <LabelsContainer>
          <LabelHeading>Questions answered</LabelHeading>
          <LabelValue>
            {report.answers.length} / {totalMaxScore}
          </LabelValue>
        </LabelsContainer>
      )}
      {isFreecode && (
        <LabelsContainer>
          <LabelHeading>Test difficulty</LabelHeading>
          <LabelValue>{report.test.difficulty}</LabelValue>
        </LabelsContainer>
      )}
      {isFreecode && (
        <LabelsContainer>
          <LabelHeading>Code language</LabelHeading>
          <LabelValue>{bestRunInput.languageVersion || Languages[bestRunInput.language].SimpleName}</LabelValue>
        </LabelsContainer>
      )}
      <LabelsContainer>
        <LabelHeading>Time used</LabelHeading>
        <LabelValue>
          {report.ticket.isOvertime
            ? getOvertimeUsed()
            : timeUsed > report.ticket.timeLimit
            ? report.ticket.timeLimit
            : timeUsed}{' '}
          min (out of
          {` ${report.ticket.timeLimit}`} min) {report.ticket.isOvertime ? '(Overtime)' : ''}
        </LabelValue>
      </LabelsContainer>
      <LabelsContainer>
        <LabelHeading>Time sent</LabelHeading>
        <LabelValue>{moment(report.ticket.createdAt).format('YYYY-MM-DD HH:mm')}</LabelValue>
      </LabelsContainer>
      <LabelsContainer>
        <LabelHeading>Time completed</LabelHeading>
        <LabelValue>{completedAt ? moment(completedAt).format('YYYY-MM-DD HH:mm') : '--'}</LabelValue>
      </LabelsContainer>
      <LabelsContainer>
        <LabelHeading>Sent by</LabelHeading>
        <LabelValue>{report.ticket.customer}</LabelValue>
      </LabelsContainer>
      {report.ticket?.reportReceivers?.length > 0 && (
        <LabelsContainer>
          <LabelHeading>Report Receiver</LabelHeading>
          <LabelValue>{report.ticket.reportReceivers.join(', ')}</LabelValue>
        </LabelsContainer>
      )}
    </InfoLabelsContainer>
  );
}
